import { Pipe, PipeTransform } from '@angular/core';
import { DateUtil } from '../util/date.util';

@Pipe({
  name: 'encryption'
})
export class EncryptionPipe implements PipeTransform {
  transform(text: any) {
    if (text) {
      text = text + "";
      if (text.length > 0) {
        let encryptedText = text[0] + "******";
        if (text.indexOf("@") > -1) {
          encryptedText += text.substring(text.indexOf("@"), text.length);
        } else {
          encryptedText += text.substring(text.length - 1, text.length);
        }

        return encryptedText;
      } else {
        return text;
      }
    } else {
      return text;
    }
  }

}
